import { useReveal } from "../../hooks/useReveal";

interface TrustItem {
  number: string;
  label: string;
  icon: string;
  detail?: string;
}

interface TrustBarProps {
  items?: TrustItem[];
}

const defaultItems: TrustItem[] = [
  { number: "15+", label: "Years of Mastery", icon: "ri-award-line", detail: "in San Antonio" },
  { number: "500+", label: "Families Served", icon: "ri-heart-line", detail: "across Texas" },
  { number: "5.0★", label: "Average Rating", icon: "ri-star-line", detail: "client reviews" },
  { number: "100%", label: "Satisfaction", icon: "ri-shield-check-line", detail: "guaranteed" },
];

export default function TrustBar({ items = defaultItems }: TrustBarProps) {
  const ref = useReveal<HTMLElement>();

  return (
    <section ref={ref} className="relative bg-pk-charcoal py-14 overflow-hidden">
      {/* Subtle texture strip */}
      <div className="absolute inset-0 opacity-5"
        style={{ backgroundImage: "repeating-linear-gradient(45deg, #C4A87A 0, #C4A87A 1px, transparent 0, transparent 50%)", backgroundSize: "12px 12px" }} />

      <div className="relative max-w-screen-xl mx-auto px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-0 md:divide-x md:divide-white/10">
          {items.map((item, i) => (
            <div key={i} className={`reveal flex flex-col items-center text-center gap-1 px-8`} style={{ transitionDelay: `${i * 80}ms` }}>
              <div className="w-10 h-10 flex items-center justify-center mb-2">
                <i className={`${item.icon} text-pk-gold text-2xl`} />
              </div>
              <span className="font-display text-4xl md:text-5xl font-semibold text-white leading-none">
                {item.number}
              </span>
              <span className="font-sans text-xs tracking-widest uppercase text-white/70 mt-1">
                {item.label}
              </span>
              {item.detail && (
                <span className="font-sans text-xs text-pk-gold/60 tracking-wide mt-0.5">
                  {item.detail}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
